import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ongksaalcjopshuronid.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9uZ2tzYWFsY2pvcHNodXJvbmlkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ3NjI2MjIsImV4cCI6MjA5MDMzODYyMn0.oR1_wpTFqDhmxDwCKwaypMKqDTwSRR9y5meT49efY2Y';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
